import { createStyles, makeStyles } from '@material-ui/core/styles'
export default makeStyles((theme) =>
    createStyles({
        wrapForm: {
            display: 'flex',
            width: '95%',
        },
        wrapText: {
            width: '100%',
        },
        button: {
            //margin: theme.spacing(1),
        },
    }),
)
